import { JobApplicantSubBaseViewController } from '@/views/portal/hr/my_profile/JobApplicantSubBaseViewController';

export class JobApplicantReferenceSubViewController extends JobApplicantSubBaseViewController {
	constructor( options = {} ) {
		_.defaults( options, {} );

		super( options );
	}

	initOptions() {
		var $this = this;
		this.api.getJobApplicantReferenceOptions( 'type', {
			onResult: function( result ) {
				$this.setSourceData( 'type_id', result.getResult(), true );
			}
		} );
		this.company_api.getOptions( 'country', {
			onResult: function( result ) {
				var result = result.getResult();
				$this.setSourceData( 'country', result, true );
			}
		} );
	}

	getJobApplicantReference( callback ) {
		var $this = this;
		var filter = {};
		filter.filter_data = {};
		filter.filter_data.id = this.model.id;
		this.api['getJobApplicantReference']( filter, {
			onResult: function( result ) {
				if ( result && result.isValid() ) {
					var result_data = result.getResult();
					if ( !result_data ) {
						result_data = [];
					}
					result_data = result_data[0];
					$this.model.set( result_data );
					if ( callback ) {
						callback();
					}
				} else {
					$this.showErrorAlert( result );
					ProgressBar.closeOverlay();
				}
			}
		} );
	}

	setCurrentEditRecordData() {
		super.setCurrentEditRecordData();
		var field_selector;
		var field_control;
		//Set current edit record data to all widgets
		for ( var key in this.model.attributes ) {
			if ( !this.model.has( key ) ) {
				continue;
			}
			// if ( this.current_edit_record[key] === false ) {
			// 	this.current_edit_record[key] = '';
			// }
			switch ( key ) {
				case 'country':
					// if ( this.current_edit_record[key] === false ) {
					// 	this.current_edit_record[key] = '';
					// }
					field_selector = 'select[name="' + key + '"]';
					this.$( field_selector ).val( this.model.get( key ) );
					if ( key === 'country' ) {
						this.eSetProvince( this.model.get( key ) );
					}
					break;
				default:
					if ( this.model.get( key ) === false ) {
						this.model.set( key, '' );
					}
					field_selector = '.form-control[name="' + key + '"]';
					field_control = this.$( field_selector );
					if ( field_control && field_control[0] ) {
						this.$( field_selector ).val( this.model.get( key ) );
					}
					break;

			}
		}
		// this.collectUIDataToCurrentEditRecord();
		// this.setEditViewDataDone();
	}

	onFormItemChange( e, doNotValidate ) {
		var key = e.currentTarget.name;
		var $this = this;
		this.model.set( key, $( e.currentTarget ).val() );
		// switch ( key ) {
		// case 'country':
		// case 'identification_country':
		// 	var widget = this.$('select[name="' + key + '"]');
		// 	widget.val( null );
		// 	break;
		// case 'is_current_employer':
		// case 'is_contact_available':
		// 	if ( $(e.currentTarget).is(':checked' ) ) {
		// 		this.model.set( key, true )
		// 	} else {
		// 		this.model.set( key, false )
		// 	}
		// 	break;
		// }
		if ( key == 'country' ) {
			this.eSetProvince( this.$( 'select[name="country"]' ).val(), true, function() {
				$this.validate();
			} );
			// this.clearErrorTips();
			return;
		}
		if ( !doNotValidate ) {
			this.validate();
		}
	}

	eSetProvince( val, refresh, callback ) {
		var $this = this;
		$this.$( 'select[name="province"]' ).selectpicker( 'destroy' );
		if ( !val || val === '-1' || val === '0' ) {
			$this.e_province_array = [];
			$this.setSourceData( 'province', [] );
		} else {
			this.company_api.getOptions( 'province', val, {
				onResult: function( res ) {
					res = res.getResult();
					if ( !res ) {
						res = [];
					}
					$this.e_province_array = Global.buildRecordArray( res );
					if ( refresh && $this.e_province_array.length > 0 ) {
						$this.model.set( 'province', $this.e_province_array[0].value );
						$this.$( 'select[name="province"]' ).val( $this.model.get( 'province' ) );
					}
					$this.setSourceData( 'province', res );
					if ( callback ) {
						callback();
					}
				}
			} );
		}
	}
}
